import React, { Component } from 'react';
import * as actions from './actions';
import * as selectors from './selectors';
import { connect } from 'react-redux';
import { LoadingBlueLarge } from 'merchant-portal-components';

function getCategories(WrappedComponent) {
  class Container extends Component {
    componentDidMount() {
      const { allCategories, getCategories } = this.props;
      if (!allCategories || allCategories.length === 0) {
        getCategories();
      }
    }
    componentDidUpdate(prevProps) {
      const { token, getCategories } = this.props;
      if (!prevProps.token && token) {
        getCategories();
      }
    }
    render() {
      const { requestingCategories, allCategories } = this.props;
      if (requestingCategories) {
        return <LoadingBlueLarge />;
      }
      return <WrappedComponent {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      allCategories: selectors.getAllCategories(state),
      requestingCategories: state.categories.requestingCategories,
      token: state.accountReducer.token,
    };
  }
  return connect(mapStateToProps, actions)(Container);
}
export default getCategories;
